import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrelevementIBD } from 'src/app/domain/IBD/prelevement-ibd';

@Component({
    selector: 'app-ibd-prelevement-box',
    templateUrl: './ibd-prelevement-box.html',
    styleUrls: ['./ibd-prelevement-box.scss']
})
export class IBDPrelevementDialog implements OnInit {

    SampleTaking: PrelevementIBD;

    constructor(
        public dialogRef: MatDialogRef<IBDPrelevementDialog>,
        @Inject(MAT_DIALOG_DATA) public data: PrelevementIBD) {
        this.SampleTaking = Object.assign({}, data);
    }

    ngOnInit() {
    }

    onCancel(): void {
        this.dialogRef.close(null);
    }

    onConfirm() {
        this.dialogRef.close(this.SampleTaking);
    }
}
